import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_10: FaireProductEntity = {
  token: "sweet-wink-10",
  type: "product",
  name: "XOXO Patch Valentine's Day Short Sleeve T-Shirt - Kids",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/ff4f64a6761bba2bad2c21c39f71e5111395c7689d07884674c6bac72c80460b.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1079,1079,x0,y0,safe&width=720",
  priceDollars: 14,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
